import React from 'react';
import 'prismjs';
import Highlight, { defaultProps } from 'prism-react-renderer';
import _style from './HighlightDisplay.scss';

const LineNumber = ({ children }) => (
  <span className={_style.lineNumber}>{children}</span>
);

export const HighlightDisplay = ({
  value,
  language,
  theme,
  dataHook = 'code-example-body',
  withLineNumber = false,
}) => {
  if (!value) {
    return null;
  }
  return (
    <Highlight {...defaultProps} code={value} language={language} theme={theme}>
      {({ className, style, tokens, getLineProps, getTokenProps }) => (
        <pre data-hook={dataHook} className={className} style={style}>
          {tokens.map((line, i) => (
            <div {...getLineProps({ line, key: i })}>
              {withLineNumber && <LineNumber>{i + 1}</LineNumber>}
              {line.map((token, key) => (
                <span {...getTokenProps({ token, key })} />
              ))}
            </div>
          ))}
        </pre>
      )}
    </Highlight>
  );
};
